import React, { useEffect } from 'react';
import PropertyFeatures from './PropertyFeatures';
import PropertyDetail from './PropertyDetail';

const PropertyFloorPlans = ({ publicUrl, floorPlans, activeTab, setActiveTab }) => {
    useEffect(() => {
        if (floorPlans?.length > 0 && !activeTab) {
            setActiveTab(floorPlans[0].id); // Set the first tab as active if none is active
        }
    }, [floorPlans, activeTab, setActiveTab]);

    const handleTabClick = (tabId, e) => {
        e.preventDefault();
        setActiveTab(tabId); // Update the active tab state
    };

    return (
        <div>
            <h4 className="title-2">Detalles del Proyecto</h4>
            <div className="ltn__apartments-plan-area product-details-apartments-plan mb-0">
                <div className="ltn__tab-menu ltn__tab-menu-3 ltn__tab-menu-top-right-- text-uppercase--- text-center--- mb-3">
                    <div className="nav">
                        {floorPlans?.map((plan) => (
                            <a
                                key={plan.id}
                                className={activeTab === plan.id ? 'active show' : ''}
                                onClick={(e) => handleTabClick(plan.id, e)}
                                href={`#${plan.id}`}
                            >
                                {plan.description}
                            </a>
                        ))}
                    </div>
                </div>
                <div className="tab-content">
                    {floorPlans?.map((plan) => (
                        <TabContent key={plan.id} plan={plan} activeTab={activeTab} />
                    ))}
                </div>
            </div>
        </div>
    );
};

const TabContent = ({ plan, activeTab }) => (
    <div className={`tab-pane fade ${activeTab === plan.id ? 'active show' : ''}`} id={plan.id}>
        <div className="ltn__apartments-tab-content-inner">
            <div className="row">
                {plan.name === 'liton_tab_3_1' && (
                    <div className="col-lg-12">
                        <PropertyFeatures features={plan.details} />
                    </div>
                )}
                {plan.name === 'liton_tab_3_2' && (
                    <div className="col-lg-12">
                        <PropertyDetail details={plan.details.length > 4 ? [plan.details.slice(0, Math.ceil(plan.details.length / 2)), plan.details.slice(Math.ceil(plan.details.length / 2))] : [plan.details]} />
                    </div>
                )}
                {plan.name === 'liton_tab_3_3' && (
                    <div className="col-lg-12">
                        <div className="property-details-google-map mb-60">
                            <iframe
                                src={plan.details[0]?.value}
                                width="100%"
                                height="100%"
                                frameBorder={0}
                                allowFullScreen
                                aria-hidden="false"
                                tabIndex={0}
                                title={`Map of ${plan.name}`}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    </div>
);

export default PropertyFloorPlans;